/**
 * Desks in the Office of the Controller of Examinations.
 *
 * Companion to examResults.ts, the way placementCell.ts is to placements.ts:
 * that file holds the published results, this one holds who to ask.
 *
 * PROVENANCE WARNING — these two desks are NOT verified.
 *
 * The Dean Examination's own details (drskumarappa@gmail.com, +91 93410 00364)
 * come from bietdvg.edu/exam and are real; they sit on the DeanBand above this
 * section rather than in this list, so he is named once on the page.
 *
 * The addresses and numbers below were inherited from the original prototype
 * and appear nowhere on the institute's site. They are the same vintage as the
 * "Dr. COE-01" placeholder that used to head this page, and as the invented
 * placement figures the placements page records having stripped out. Structuring
 * them here makes them look more authoritative than they are — so this note
 * exists to say plainly that they need checking before this page goes live.
 */

/**
 * The Dean Examination's published reach, from bietdvg.edu/exam. Name and role
 * stay in deans.ts; these two fields were hardcoded in Examinations.tsx and are
 * lifted here so /contact can cite the same source rather than a second copy.
 */
export const EXAM_DEAN_REACH = {
  phone: "+91 93410 00364",
  email: "drskumarappa@gmail.com",
};

export interface ExamContact {
  /** Mono label above the name, e.g. "Certificates". */
  ctype: string;
  name: string;
  phone?: string;
  email?: string;
  /** One extra labelled line — opening hours, turnaround, whatever the desk publishes. */
  extra?: { label: string; value: string };
}

export const EXAM_CONTACTS: ExamContact[] = [
  {
    ctype: "Certificates",
    name: "Certificates desk",
    phone: "+91 8192 233 822",
    email: "certificates@bietdvg.edu",
    extra: { label: "Hours", value: "Mon–Fri · 10:00 to 16:00" },
  },
  {
    ctype: "Verification",
    name: "Third-party verification",
    email: "verify@bietdvg.edu",
    extra: { label: "Turnaround", value: "3 working days" },
  },
];
